import { Fragment } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import { Logo } from "../common/Logo";

type PDFTableProps = {
    heads?: string[];
    rows?: string[][];
}

const PDFTable = (props: PDFTableProps) => {

    const { t } = useTranslation();
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 mt-4 mb-4">
                        <div className="row">
                            <div className="col-8">
                                <Logo />
                            </div>
                            <div className="col-4 text-end">
                                <span>{dayjs().format("DD.MM.YYYY HH:mm")}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <table className="table mt-4 mb-4">
                            <thead>
                                <tr>
                                    {
                                        props.heads
                                        &&
                                        props.heads.length > 0
                                        &&
                                        props.heads.map((head: string, index: number) => (
                                            <Fragment key={index}>
                                                <th>{t(head)}</th>
                                            </Fragment>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.rows
                                    &&
                                    props.rows.length > 0
                                    &&
                                    props.rows.map((row: string[], index: number) => (
                                        <tr>
                                            {
                                                row.map((col: string, indexCol: number) => (
                                                    <Fragment key={indexCol}>
                                                        <td>{col}</td>
                                                    </Fragment>
                                                ))
                                            }
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PDFTable;